export default [   
 
  {
    id: '1',
    icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/19972.png',
    symbol: 'rloop',
    name: 'rLoop',
    decimals: '18',
    address: '0x822b906e74d493d07223cf6858620ccda66b2154',
    vesting_period: '24 Months',
    explorer: 'https://snowtrace.io/', 
    network: "Avalanche",
    display_price: "0.0181",
    exchange_rate: '0.0181',
    initial_price: "0.005554",
    coinmarketcap: "https://coinmarketcap.com/currencies/rloop/"
  }, 
  {
    id: '2',
    icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/17587.png',
    symbol: 'KACY',
    name: 'Kassandra',
    decimals: '18',
    address: '0xf32398dae246C5f672B52A54e9B413dFFcAe1A44',
    vesting_period: '24 Months',
    explorer: 'https://snowtrace.io/', 
    network: "Avalanche",
    display_price: "0.0097",
    exchange_rate: '0.0097',
    initial_price: "0.003238",
    coinmarketcap: "https://coinmarketcap.com/currencies/kassandra/"
  },

  {
    id: '3',
    icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11961.png',
    symbol: 'VEE',
    name: 'Vee',
    decimals: '18',
    address: '0x3709E8615E02C15B096f8a9B460ccb8cA8194e86',
    vesting_period: '24 Months',
    explorer: 'https://snowtrace.io/', 
    network: "Avalanche",
    display_price: "0.00015",
    exchange_rate: '0.00015',
    initial_price: "0.00005213",
    coinmarketcap: "https://coinmarketcap.com/currencies/vee-finance/"
  },
  {
    id: '4',
    icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/16231.png',
    symbol: 'PTP',
    name: 'Platypus',
    decimals: '18',
    address: '0x22d4002028f537599bE9f666d1c4Fa138522f9c8',
    vesting_period: '24 Months',
    explorer: 'https://snowtrace.io/', 
    network: "Avalanche",
    display_price: "0.00059",
    exchange_rate: '0.00059',
    initial_price: "0.0001549",
    coinmarketcap: "https://coinmarketcap.com/currencies/platypus-finance/"
  },
   
  {
    id: '5',
    icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/15191.png',
    symbol: 'MELT',
    name: 'Defrost Finance Token',
    decimals: '18',
    address: '0x47EB6F7525C1aA999FBC9ee92715F5231eB1241D', 
    vesting_period: '24 Months',
    explorer: 'https://snowtrace.io/', 
    network: "Avalanche",
    display_price: "0.00125",
    exchange_rate: '0.00125', 
    initial_price: "0.0004175",
    coinmarketcap: "https://coinmarketcap.com/currencies/defrost-finance/"
  },  
  {
    id: '6',
    icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/18840.png',
    symbol: 'DEG',
    name: 'DegisToken',
    decimals: '18',
    address: '0x9f285507ea5b4f33822ca7abb5ec8953ce37a645',
    vesting_period: '24 Months',
    explorer: 'https://snowtrace.io/', 
    network: "Avalanche",
    display_price: "0.00019",
    exchange_rate: '0.00019',
    initial_price: "0.00005622",
    coinmarketcap: "https://coinmarketcap.com/currencies/degis/"
  },

];
